import Record from "./base"

export default class Client extends Record {
  constructor(...args) {
    super(...args)
    const [model, props] = args
  }
}
